@use '../../../scss/utility/functions' as utility;
@use 'subnavigation-item-vars';

:host {
  @include subnavigation-item-vars.wb-subnavigation-item-vars;
  display: block;
}

.tag {
  display: flex;
  align-items: center;
  padding: var(--subnavigation-item-padding);
  color: var(--subnavigation-item-text-color);
  background-color: var(--subnavigation-item-background-color);
  border-radius: var(--subnavigation-item-border-radius);
  white-space: nowrap;
  text-decoration: none;
  outline: none;
}

.label {
  position: relative;
}

button {
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
}

.notification {
  position: absolute;
  inset-block-start: calc(var(--subnavigation-item-indicator-size) * -0.5);
  inset-inline-end: calc(var(--subnavigation-item-indicator-size) * -1);
  height: var(--subnavigation-item-indicator-size);
  width: var(--subnavigation-item-indicator-size);
  background-color: var(--subnavigation-item-indicator-color);
  border-radius: var(--wb-radius-full);
}

::slotted(.wb-icon),
.chevron {
  margin-inline-start: var(--subnavigation-item-gap);
  color: var(--subnavigation-item-icon-color);
}

::slotted(.wb-icon) {
  --size: var(--subnavigation-item-icon-size);
}

.chevron {
  --size: #{utility.wb-pixel-to-rem(12px)};
}

.tag:hover,
.tag:focus {
  @include subnavigation-item-vars.wb-subnavigation-item-hover-vars;
}

:host([active]) .tag {
  @include subnavigation-item-vars.wb-subnavigation-item-selected-vars;
}
